/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { setLocationUrlAction } from './urlchangeevents.actions';
import { SET_LOCATION_URL } from './urlchangeevents.types';
import { DeviceModel } from '../../core/device';

const initialState: {
    url: string;
} = {
    url: '',
};

const urlChangeEventsReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SET_LOCATION_URL:
            return {
                ...state,
                url: payload.url,
            };
        default:
            return state;
    }
};

export const setLocationUrl = (url: string) => (dispatch: Function) => {
    //  this line change is to support local development
    const newUrl =
        DeviceModel.getAppHomePage() === '/' ? url : `${DeviceModel.getAppHomePage()}${url}`;
    window.history.pushState('', '', newUrl);
    dispatch(setLocationUrlAction(url));
};

export default urlChangeEventsReducer;
